import styled from '@emotion/styled';
import { theme } from '../../../theme/theme';

interface TextTinyProps {
  lineHeight?: React.CSSProperties['lineHeight'];
  textAlign?: React.CSSProperties['textAlign'];
  color?: React.CSSProperties['color'];
  children: React.ReactNode;
}

export function TextTiny(props: TextTinyProps) {
  return (
    <S.Root
      style={{
        '--text-tiny-line-height': props.lineHeight,
        '--text-tiny-text-align': props.textAlign,
        '--text-tiny-color': props.color,
      }}
    >
      {props.children}
    </S.Root>
  );
}

interface CSSProperties {
  '--text-tiny-line-height'?: TextTinyProps['lineHeight'];
  '--text-tiny-text-align'?: TextTinyProps['textAlign'];
  '--text-tiny-color'?: TextTinyProps['color'];
}

const S = (TextTiny.S = class S {
  static Root = styled.div<{ style: CSSProperties }>`
    font-size: ${theme.fontSize.tiny};
    font-weight: ${theme.fontWeight.regular};
    line-height: var(--text-tiny-line-height, 14px);
    text-align: var(--text-tiny-text-align, start);
    color: var(--text-tiny-color, ${theme.color.text});
  `;
});
